module.exports = __webpack_public_path__ + "img/minimal.df95f49a.png";